import { Nullable } from '@clearverify/types';

import { RevenueShareType } from 'src/api';

export enum VerifierBillingRulesFormFields {
  voI = 'voI',
  voE = 'voE',
  reverification = 'reverification',
}

export enum EmployerInitialBillingFormFields {
  revenueShare = 'revenueShare',
  revenueShareType = 'revenueShareType',
}

export type VerifierBillingRulesFormFieldsValues = Record<
  VerifierBillingRulesFormFields,
  Nullable<number>
>;

export type EmployerBillingRulesFormFieldsValues = {
  [EmployerInitialBillingFormFields.revenueShare]: Nullable<number>;
  [EmployerInitialBillingFormFields.revenueShareType]: Nullable<RevenueShareType>;
};

export enum RevenueFieldNameTypeMap {
  Percents = 'revenueSharePercents',
  Flat = 'revenueShareFlat',
}
